import React from 'react';
import PropTypes from 'prop-types';
import { withPrefix } from 'gatsby';

import { withStyles } from '../tools/withStyles';
import { Main } from '../components/Main';
import { Secuence } from '../components/Secuence';
import { Text } from '../components/Text';
import { Fader } from '../components/Fader';
import { Link } from '../components/Link';
import { Button } from '../components/Button';

const styles = theme => ({
  root: {},
  lead: {
    maxWidth: 680
  },
  highlight: {
    fontFamily: theme.typography.primary,
    fontSize: 42,
    lineHeight: 1,
    color: theme.color.secondary.main
  },
  photo: {
    display: 'block',
    width: '100%',
    maxWidth: 640,
    margin: [8, 'auto', 16]
  }
});

class Vinilo extends React.Component {
  static propTypes = {
    classes: PropTypes.object
  };

  render () {
    const { classes } = this.props;

    return (
      <Main className={classes.root}>
        <Secuence stagger>
          <h1><Text>Vinilo firmado por Yoko</Text></h1>
          <Fader>
            <img
              className={classes.photo}
              src={withPrefix('/images/vinilo.png')}
              alt='Portada del vinilo de A Cruel Angel’s Thesis y disco edición limitada, 40 por país'
            />
            <p className={classes.highlight}>40 / país</p>
          </Fader>
          <p className={classes.lead}>
            <Text>Yoko firma personalmente cada copia. Solo existen 40 por país. La foto, la firma y el disco se consiguen en la tienda, aparte de la entrada.</Text>
          </p>
          <p className={classes.lead}>
            <Fader>Portal Pop Culture produce la parada de Costa Rica: la unión entre la ficción y la realidad, entre artistas y fans. El vinilo firmado está en la tienda del concierto.</Fader>
          </p>
          <p>
            <Link href='/tienda'>
              <Button>Ver la tienda</Button>
            </Link>
          </p>
        </Secuence>
      </Main>
    );
  }
}

export default withStyles(styles)(Vinilo);
